(function ($) {
    const behavior = 'hkust_sa.gallery';
    Drupal.behaviors[behavior] = {
        attach: (context, settings) => {
        }
        
    };
    $(function () {
        hkust_sa_handle_image_masonry();
        hkust_sa_handle_image_display();
        hkust_sa_handle_image_hide();
        hkust_sa_handle_window_scroll();
    });
    
    function hkust_sa_handle_image_masonry() {
        var grid = buildMasonry();
        masonryCheckPosition();
        
        $(window).resize(function () {
            grid.masonry('layout');
            masonryCheckPosition();
        });
        
        $(document).ajaxComplete(function () {
            grid.masonry('destroy');
            grid = buildMasonry();
            masonryCheckPosition();
        });
    }
    
    function buildMasonry() {
        return $('.mtpc-single-album .ustsa-album__image').masonry({
            // options...
            itemSelector: 'article',
            gutter: 20,
        });
    }
    
    function masonryCheckPosition() {
        if ($('.mtpc-single-album .ustsa-album__image article').length == 0) {
            return;
        }
        
        $('.mtpc-single-album .ustsa-album__image article').each(function () {
            if (parseInt($(this).css('left'), 10) > 0) {
                $(this).removeClass('masonry-left');
                $(this).addClass('masonry-right');
            } else {
                $(this).removeClass('masonry-right');
                $(this).addClass('masonry-left');
            }
        });
    }
    
    function hkust_sa_handle_image_display() {
        $('.mtpc-single-album .ustsa-album__image article').on('click', function () {
            var slideShowSelector = $('.image-layer .mtpc-block-slideshow-block .slick_slideshow');
            var key = $(this).index();
            $('.image-layer').show();
            slideShowSelector.css('opacity', 0);
            mtpc_initSlick(slideShowSelector, key);
            slideShowSelector.slick('slickGoTo', key);
            slideShowSelector.on('afterChange', function () {
                slideShowSelector.css('opacity', 1);
            });
        });
    }
    
    function hkust_sa_handle_image_hide() {
        $('.image-layer .cnt_close_menu_button').on('click', function () {
            $(this).parents('.image-layer').hide();
            var slideShowSelector = $('.image-layer .mtpc-block-slideshow-block .slick_slideshow');
            slideShowSelector.slick('unslick');
        });
    }
    
    function mtpc_initSlick(slideShowSelector) {
        var slideShowSelector = $('.image-layer .mtpc-block-slideshow-block .slick_slideshow');
        
        // Check if Slick selector exists in the DOM
        if (slideShowSelector.length > 0) {
            slideShowSelector.each(function () {
                
                // Init slick if not initiated
                $(this).not('.slick-initialized').slick();
                
                // Hide slide dots if only one slide
                var total = $(this).find('.slideshow_item').length;
                if (total <= 1) {
                    $(this).addClass('forceHideDots');
                }
    
                $(this).on('init reInit afterChange', function (event, slick, currentSlide) {
                    $('.image-layer .mtpc-block-slideshow-block .slick-qty').html(`<p>${currentSlide+1} / ${total}</p>`);
                });
    
    
            });
        }
    }
    
    function hkust_sa_handle_window_scroll() {
        $(window).on('scroll', function () {
            let windowScrollTop = $(window).scrollTop();
            let headerHeight = $('header').height();
            let galleryHeight = $('.mtpc-gallery-container').height();
            let galleryInfoHeight = $('.mtpc-gallery-left-section').height();
            let scrolledTop = windowScrollTop - headerHeight - 60;
            
            if (windowScrollTop > 60) {
                if ((galleryHeight - scrolledTop) > (galleryInfoHeight + 60)) {
                    $('.mtpc-gallery-left-section').css('top', scrolledTop + 'px');
                }
            }
            
            if (windowScrollTop <= 60) {
                $('.mtpc-gallery-left-section').css('top', '0');
            }
        });
    }
    
})(jQuery);